/**
 * Created by USER on 18/8/9.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {message, Modal, Button} from 'antd';
import {sha256} from 'js-sha256';
import bs58 from 'bs58';
import {changeBarState} from '../redux/actions/headerbar_action';
import httpClient from '../swagger/swagger';
import imgList from '../images/img';

const { client, setAccesskey } = httpClient;

class Wechat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationModal: false,
      orderData: {}
    };
  }
  componentWillMount() {
    this.props.dispatch(changeBarState('wechat'));
  }

  componentDidMount() {
    this.setState({
      paymentQrcode: window.localStorage.getItem('wechatQrcode')
    });
    if (JSON.parse(window.localStorage.getItem('order')) !== null){
      const {order} = JSON.parse(window.localStorage.getItem('order'));
      setAccesskey(this.makeToken()).then(() => {
        client.then((oclient) => {
          oclient.apis.order.get_v1_order_id_ispay({ // 请求订单是否支付
            id: order,
          }).then((result) => {
            if (result.obj.code === 200) {
              if (result.obj.ispay) {
                this.setState({
                  verificationModal: true
                });
              }
            }
          }).catch(() => message.error(this.props.t('request_error')));
        }).catch(() => message.error('服务器开小差了'));

        client.then((oclient) => {
          oclient.apis.order.get_v1_order_id({ // 请求订单的详细信息
            id: order,
          }).then((result) => {
            if (result.obj.code === 200) {
              this.setState({
                orderData: result.obj
              });
            } else {
              message.error(this.props.t('get_order_fail'));
            }
          }).catch(() => message.error(this.props.t('request_error')));
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => {});
    } else {
      this.props.history.push('/product');
    }
  }

  makeToken() { // 配置请求的token
    const {notice_mobile} = JSON.parse(window.localStorage.getItem('order'));
    const mobileSha = sha256(sha256.digest(notice_mobile));
    const timestamp = parseInt(new Date().getTime() / 1000, 10).toString();
    const another = mobileSha.slice(timestamp.length);
    let token = '';
    for (let i = 0; i < timestamp.length; i++) {
      token += mobileSha[i] + timestamp[i];
    }
    const bytes = Buffer.from(token + another, 'hex');
    return bs58.encode(bytes);
  }

  completePay() { // 去支付
    const {order} = JSON.parse(window.localStorage.getItem('order'));
    setAccesskey(this.makeToken()).then(() => {
      client.then((oclient) => {
        oclient.apis.order.get_v1_order_id_ispay({ // 请求订单是否支付
          id: order,
        }).then((result) => {
          if (result.obj.code === 200) {
            if (result.obj.ispay) {
              window.close();
            } else {
              message.error(this.props.t('payment_un_complete'));
            }
          } else {
            message.error(this.props.t('payment_un_complete'));
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
  }

  render() {
    const {paymentQrcode, orderData} = this.state;
    const {t} = this.props;
    return (
      <div className="wechatPay">
        <div className="wechatPay_area">
          <div className="wechatPay_title">
            <img src={imgList.img.english} alt="LUBANSO" />
            <img src={imgList.img.wechatPay} alt="LUBANSO" />
          </div>
          <div className="wechatPay_order_information">
            <div className="wechatPay_order_information_orderId">
              <span>{t('wechat_order')}:</span>
              <span>{orderData.order_number ? orderData.order_number : 'N/A'}</span>
            </div>
            <div className="wechatPay_order_information_price">
              <span>￥</span>
              <span>{orderData.order_price ? orderData.order_price : 'N/A'}</span>
            </div>
          </div>
          <div className="weichatPay_content">
            <div className="weichatPay_content_qrcode">
              <div className="weichatPay_content_qrcode_title">{t('wechat')}</div>
              <img src={paymentQrcode} alt="LUBANSO" />
              <div className="weichatPay_content_qrcode_notice">
                <div>
                  <img src={imgList.img.flickingLogo} alt="LUBANSO" className="weichatPay_content_flicking_logo" />
                </div>
                <div>
                  <div>{t('wechat_notice')}</div>
                  <div>{t('wechat_notice1')}</div>
                </div>
              </div>
            </div>
            <div className="weichatPay_content_guide">
              <img src={imgList.img.flickingGuide} alt="LUBANSO" />
            </div>
          </div>
          <div className="complete_button">
            <Button className="button_style" onClick={() => this.completePay()}>{t('wechat_complete')}</Button>
          </div>
        </div>
        <Modal
          title=""
          visible={this.state.verificationModal}
          footer={null}
          wrapClassName="vertical-center-modal"
          closable={false}
          maskClosable={false}
        >
          <div className="prompt_modal">
            <div>
              {t('wechat_fail')}
            </div>
            <div>
              <Link to="/">
                <Button className="button_style" >{t('wechat_fail_button')}</Button>
              </Link>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer,
  };
}

const WechatConnected = connect(select)(Wechat);

export default translate('translations')(WechatConnected);
